
export const elementFields = [
  {
    key: 'position',
    name: 'position',
    id: 'position',
    type: 'text',
    label: 'Позиция',
    required: false,
    error: '',
    fullWidth: false,
    multiline: false,
    depend: '',
  },
  {
    key: 'image_url',
    name: 'image',
    id: 'image',
    type: 'file',
    label: 'Изображение',
    required: false,
    error: '',
    fullWidth: false,
    multiline: false,
    depend: 'image',
  },
  {
    key: 'video_url',
    name: 'video_url',
    id: 'video_url',
    type: 'text',
    label: 'Ссылка на видео',
    required: false,
    error: '',
    fullWidth: true,
    multiline: false,
    depend: 'video',
  },
  {
    key: 'text',
    name: 'text',
    id: 'text',
    type: 'text',
    label: 'Текст',
    required: false,
    error: '',
    fullWidth: true,
    multiline: true,
    depend: 'text',
  },
  {
    key: 'string_type',
    name: 'string_type',
    id: 'string_type',
    type: 'select',
    label: 'Тип строки',
    choicesUrl: '/user_flows/string_types/choices/',
    required: false,
    error: '',
    fullWidth: false,
    multiline: false,
    depend: 'string',
  },
  {
    key: 'string',
    name: 'string',
    id: 'string',
    type: 'text',
    label: 'Строка',
    required: false,
    error: '',
    fullWidth: true,
    multiline: false,
    depend: 'string',
  },
  {
    key: 'phone_text',
    name: 'phone_text',
    id: 'phone_text',
    type: 'text',
    label: 'Текст под телефоном',
    required: false,
    error: '',
    fullWidth: true,
    multiline: true,
    depend: 'chatbot',
  },
  {
    key: 'ask_phone',
    name: 'ask_phone',
    id: 'ask_phone',
    type: 'checkbox',
    label: 'Запрашивать телефон',
    required: false,
    error: '',
    fullWidth: false,
    multiline: false,
    depend: 'chatbot',
  },
  {
    key: 'links_text',
    name: 'links_text',
    id: 'links_text',
    type: 'text',
    label: 'Текст под ссылками',
    required: false,
    error: '',
    fullWidth: true,
    multiline: true,
    depend: 'chatbot',
  },
  {
    key: 'flow_messages',
    name: 'flow_messages',
    id: 'flow_messages',
    type: 'select',
    label: 'Поток сообщений',
    choicesUrl: '/user_flows/flow_messages/choices/',
    required: false,
    error: '',
    fullWidth: false,
    multiline: false,
    depend: 'chatbot',
  },
];

const mainFields = [
  {
    key: 'title',
    name: 'title',
    id: 'title',
    type: 'text',
    label: 'Название',
    required: true,
    error: false,
    errorMessage: 'Пожалуйста, заполните это поле',
    fullWidth: true,
    validateArgs: {
      required: 'Это поле обязательно',
    },
  },
  {
    key: 'flow_messages',
    name: 'flow_messages',
    id: 'flow_messages',
    type: 'select',
    label: 'Поток сообщений',
    choicesUrl: '/user_flows/flow_messages/choices/',
    required: true,
    error: false,
    errorMessage: 'Пожалуйста, заполните это поле',
    fullWidth: true,
  },
  {
    key: 'chatbot_type',
    name: 'chatbot_type',
    id: 'chatbot_type',
    type: 'select',
    label: 'Чат бот',
    choicesUrl: '/user_flows/chatbot_type/choices/',
    required: true,
    error: false,
    errorMessage: 'Пожалуйста, заполните это поле',
    fullWidth: true,
  },
  {
    key: 'landing_template',
    name: 'landing_template',
    id: 'landing_template',
    type: 'select',
    label: 'Шаблон лендинга',
    choicesUrl: '/user_flows/landing_template/choices/',
    required: false,
    error: false,
    errorMessage: 'Пожалуйста, заполните это поле',
    fullWidth: true,
  },
  {
    key: 'landing_slug',
    name: 'landing_slug',
    id: 'landing_slug',
    type: 'text',
    label: 'Уникальное имя лендинга',
    required: false,
    error: false,
    errorMessage: 'Пожалуйста, заполните это поле',
    fullWidth: true,
    validateArgs: {
      required: 'Это поле обязательно',
    },
  },
  {
    key: 'use_by_default',
    name: 'use_by_default',
    id: 'use_by_default',
    type: 'checkbox',
    label: 'Использовать по-умолчанию',
    required: false,
    error: false,
    errorMessage: 'Пожалуйста, заполните это поле',
    fullWidth: true,
    validateArgs: {
      required: 'Это поле обязательно',
    },
  },
];
export default mainFields;
